import { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button, ConfigProvider, Flex, Form, Typography } from 'antd';
import { CustomRegistrationFormInput } from '../../../components';
import AlertFieldsMandatory from '../../../components/AlertFieldsMandatory/AlertFieldsMandatory';
import { API } from '../../../services';
import { ErrorMessageContext } from '../../../context/ErrorMessageContext';
import { INITIAL_TRIP_START_END_PAYLOAD } from '../../../utilities/constants';
import { getErrorMessage } from '../../../utilities/commonFunctions';

const { Title, Text } = Typography;

function TripStartEnd({ type = 'start' }) {
  const [form] = Form.useForm();
  const { addErrorMessage } = useContext(ErrorMessageContext);

  // Set status and button label based on type
  const isStart = type === 'start';
  const tripStatus = isStart ? 'STARTED' : 'COMPLETED';
  const buttonLabel = isStart ? 'Start Trip' : 'End Trip';

  const onFinish = async values => {
    try {
      await form.validateFields();
      const payload = {
        ...INITIAL_TRIP_START_END_PAYLOAD,
        clientId: values.client_id,
        tripId: values.trip_id,
        tripStatus,
      };
      const { status } = await API.manageTrip(payload);
      if (status === 200) {
        form.resetFields();
        addErrorMessage(
          `Trip ${type} notification sent successfully`,
          'success'
        );
      }
    } catch (error) {
      addErrorMessage(
        getErrorMessage(
          error,
          `Unable to send trip ${type} notification. Please try again later`
        )
      );
      return;
    }
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Typography: {
            titleMarginBottom: 0,
            titleMarginTop: 0,
            fontSize: '1rem',
          },
        },
      }}
    >
      <Flex className="full-width" justify="center">
        <Form
          layout="vertical"
          className="trip-management-form"
          scrollToFirstError
          requiredMark={false}
          form={form}
          onFinish={onFinish}
        >
          <AlertFieldsMandatory />
          <div
            style={{
              backgroundColor: 'var(--primary-fill-color, #1A1C1D)',
              padding: '32px 100px',
            }}
          >
            <Title
              level={5}
              style={{ fontSize: 24, marginTop: 0, marginBottom: 32 }}
            >
              {isStart ? 'Trip Start' : 'Trip End'}
            </Title>
            <CustomRegistrationFormInput
              label={<Text strong>Client ID</Text>}
              placeholder="Enter client ID"
              name="client_id"
              rules={[{ required: true, message: 'Please enter client ID' }]}
            />
            <CustomRegistrationFormInput
              label={<Text strong>Trip ID</Text>}
              placeholder="Enter trip ID"
              name="trip_id"
              rules={[{ required: true, message: 'Please enter trip ID' }]}
            />
          </div>
          <Flex gap={24} justify="end" style={{ marginTop: 32 }}>
            <Button
              type="primary"
              onClick={() => form.submit()}
              style={{ width: 188 }}
            >
              {buttonLabel}
            </Button>
          </Flex>
        </Form>
      </Flex>
    </ConfigProvider>
  );
}

TripStartEnd.propTypes = {
  type: PropTypes.string,
};

export default TripStartEnd;
